// extracted by mini-css-extract-plugin
export default {"panel":"AddWebLink_panel__+a2JV","panel_body":"AddWebLink_panel_body__2Ub-P","radio":"AddWebLink_radio__7hONm","d_flex":"AddWebLink_d_flex__cbgnJ"};